module.exports = __webpack_public_path__ + "static/media/DNA.0b330560.png";